import { Group, Stack, Text } from "@mantine/core";
import Icon from "./Icon";

const LabeledData = ({ label, icon, value, textStyle }) => {
  return (
    <Stack gap={6}>
      <Text size="sm" color="dimmed" fw={400}>{label}</Text>
      <Group>
        <Icon name={icon} />
        <Text style={textStyle}>{value}</Text>
      </Group>
    </Stack>
  )
}

export default LabeledData;